// Bind the catalog during module initialization as well as runtime setup.
// A missing/blocked runtime script must not select the upstream landing page.
const workshopApi = new URL(window.STAC_BROWSER_CONFIG?.catalogUrl || '/', window.location.href);
if (!window.STAC_BROWSER_CONFIG?.catalogUrl) workshopApi.port = '8082';
window.STAC_BROWSER_CONFIG = Object.assign({
  catalogUrl: workshopApi.href,
  historyMode: 'hash',
  locale: 'en',
  supportedLocales: ['en'],
  detectLocaleFromBrowser: false,
  displayPreview: false,
  displayOverview: true,
  displayOverviewsForChildren: true,
  transactions: false,
}, window.STAC_BROWSER_CONFIG);
window.STAC_BROWSER_CONFIG.catalogUrl ||= workshopApi.href;
// Presentation-only hierarchy: keep the API's search links and dataset IDs.
window.STAC_BROWSER_CONFIG.catalogTitle = 'EUMETSAT Conference 2026';
window.STAC_BROWSER_CONFIG.apiCatalogPriority = 'childs';
// FCI assets carry named bands for discovery. The stored arrays have no band
// axis: explicitly select their single variable for the GeoZarr reader.
window.STAC_BROWSER_CONFIG.getMapSourceOptions = (type, options, asset) => {
  if (String(type) === 'GeoZarr' && asset?.getMetadata('eumetsat:catalogue_id') === 'EO:EUM:DAT:0662') {
    options.variable = asset.getMetadata('fci:variable');
    options.dimensions = {time: asset.getMetadata('fci:preview_time_index') ?? 0};
    options.projection = 'EPSG:4326';
    delete options.bands;
  }
  return options;
};
window.STAC_BROWSER_CONFIG.preprocessSTAC = stac => {
  if (!['eumetsat-dmet-prototype', 'fire-emissions', 'mtg-fci', 'EO:EUM:DAT:0416', 'EO:EUM:DAT:0662'].includes(stac.id)) {
    return stac;
  }
  const Link = stac.getSelfLink().constructor;
  const local = path => new URL('/generated/catalog/' + path, window.location.href).href;
  const collectionUrl = new URL('collections/EO:EUM:DAT:0416', workshopApi);
  if (stac.id === 'eumetsat-dmet-prototype') {
    stac.title = 'EUMETSAT Conference 2026';
    stac.links = stac.links.filter(link => link.rel !== 'child');
    stac.links.push({rel: 'child', href: local('fire/catalog.json'), type: 'application/json', title: 'Fire Collection Group'});
    stac.links.push({rel: 'child', href: local('fci/catalog.json'), type: 'application/json', title: 'MTG / FCI Collection Group'});
  }
  if (stac.id === 'fire-emissions') {
    stac.links = stac.links.map(link => link.rel === 'child'
      ? {...link, href: collectionUrl.href} : link);
  }
  if (stac.id === 'EO:EUM:DAT:0416') {
    stac.links = stac.links.filter(link => link.rel !== 'parent');
    stac.links.push({rel: 'parent', href: local('fire/emissions/catalog.json'), type: 'application/json'});
    // Also support already-bookmarked static Collection URLs. The browser's
    // data view and map load full Item features through rel=items, not rel=item.
    if (!stac.links.some(link => link.rel === 'items')) {
      stac.links.push({rel: 'items', href: collectionUrl.href + '/items', type: 'application/geo+json'});
    }
  }
  if (stac.id === 'mtg-fci') {
    collectionUrl.href = new URL('collections/EO:EUM:DAT:0662', workshopApi).href;
    stac.links = stac.links.map(link => link.rel === 'child'
      ? {...link, href: collectionUrl.href} : link);
  }
  if (stac.id === 'EO:EUM:DAT:0662') {
    collectionUrl.href = new URL('collections/EO:EUM:DAT:0662', workshopApi).href;
    stac.links = stac.links.filter(link => link.rel !== 'parent');
    stac.links.push({rel: 'parent', href: local('fci/catalog.json'), type: 'application/json'});
    if (!stac.links.some(link => link.rel === 'items')) {
      stac.links.push({rel: 'items', href: collectionUrl.href + '/items', type: 'application/geo+json'});
    }
  }
  // The hook receives stac-js objects: retain Link methods/context after edits.
  stac.links = Link.fromLinks(stac.links, stac);
  return stac;
};
